import React, { useState } from "react";
import ascIcon from "../assets/icon_sort_ascending.svg";
import descIcon from "../assets/icon_sort_descending.svg";
import { ORDER_OPTIONS, isAscending } from "../utils/taskOrderSetting";

// Floating sort button, mirroring Android's FloatingSortButton: a 36px circle
// on the right edge of the label strip row that shows an ascending/descending
// icon (direction-aware) and opens a dropdown of the order modes. The active
// mode is primary-tinted with a trailing dot. `excludeDueDate` hides the Due
// Date options (e.g. on the Notes tab), like Android.
const TaskSortButton = ({ currentMode, onSelect, excludeDueDate = false }) => {
  const [open, setOpen] = useState(false);
  const options = ORDER_OPTIONS.filter(
    (o) => !(excludeDueDate && o.value.startsWith("DUE_DATE"))
  );

  return (
    <div style={styles.wrap}>
      <button
        onClick={() => setOpen((o) => !o)}
        aria-label="Sort order"
        title="Sort order"
        style={styles.circleBtn}
      >
        <img
          src={isAscending(currentMode) ? ascIcon : descIcon}
          alt=""
          style={styles.icon}
        />
      </button>
      {open && (
        <>
          <div style={styles.overlay} onClick={() => setOpen(false)} />
          <div style={styles.menu}>
            {options.map((opt) => {
              const selected = opt.value === currentMode;
              return (
                <div
                  key={opt.value}
                  style={styles.item}
                  onClick={() => {
                    onSelect(opt.value);
                    setOpen(false);
                  }}
                >
                  <span style={{ color: selected ? "var(--primary)" : "var(--text)" }}>
                    {opt.label}
                  </span>
                  {selected && <span style={styles.dot} />}
                </div>
              );
            })}
          </div>
        </>
      )}
    </div>
  );
};

const styles = {
  wrap: { position: "relative", flexShrink: 0 },
  circleBtn: {
    width: "36px",
    height: "36px",
    borderRadius: "50%",
    border: "none",
    backgroundColor: "var(--surface)",
    boxShadow: "0 2px 6px rgba(0, 0, 0, 0.3)",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: 0,
  },
  icon: { width: "18px", height: "18px", filter: "var(--icon-filter)" },
  overlay: {
    position: "fixed",
    inset: 0,
    zIndex: 1000,
  },
  menu: {
    position: "absolute",
    top: "100%",
    right: 0,
    marginTop: "6px",
    backgroundColor: "var(--surface)",
    border: "1px solid var(--border)",
    borderRadius: "8px",
    boxShadow: "0 4px 16px rgba(0, 0, 0, 0.3)",
    zIndex: 1001,
    minWidth: "max-content",
    padding: "4px",
  },
  item: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "16px",
    padding: "8px 12px",
    cursor: "pointer",
    fontSize: "14px",
    borderRadius: "6px",
    whiteSpace: "nowrap",
  },
  dot: {
    width: "8px",
    height: "8px",
    borderRadius: "50%",
    backgroundColor: "var(--primary)",
    flexShrink: 0,
  },
};

export default TaskSortButton;
